export function isPortalPath(pathname) {
    if (!pathname) return false;
    // treat /portal, /portal/... (dashboard)
    // and /portal/invite, /portal/recover, etc. as "portal context"
    return pathname.startsWith('/portal');
  }